export default {
  companyInfo: '公司信息',
  companyName: '公司名稱',
  legalPerson: '法人/主負責人（公司）',
  nameNoteAndCompanyName: '名稱備註/原公司名',
  nickName: '暱稱',
  nature: '公司類別', // 公司/個人/工作室/國際學校/其他
  natureNote: '類別說明',
  location: '所在區域',
  companyAddress: '公司詳細地址',
  parentName: '所屬父代理',
  taxCode: '稅號/統一社會信用代碼（公司）',
  isSettlementPort: '佣金是否單獨結算', // 0否/1是
  idCardNum: '身份證號（個人/法人）',
  firstContractTime: '合同首次創建時間',
  firstOfferItemTime: '首次創建申請時間',
  remark: '備註',
  accountList: '賬號列表',
  authorityQuery: '權限查詢',
  businessDataManagement: '業務數據管理',
  subcompanyList: '分公司列表',
  roleType: '角色類型',
  department: '部門',
  administrator: '管理者',
  finance: '財務',
  subagentDataOpenSet: '子代理數據開放設置',
  bmsDataOpenSet: 'BMS數據開放設置',
  businessSupervisor: '業務上司',
  viewSubordinate: '查看下屬',
  companyNumber: '編號',
  legalPersonName: '法人姓名',
  largeArea: '大區',
  area: '區域',
  bindStudentNum: '綁定學生數',
  addAccount: '新增賬號',
  editAccount: '編輯賬號',
  mobile: '移動電話',
  mobileAreaCode: '移動電話區號',
  telAreaCode: '固定電話區號',
  tel: '固定電話',
  // isCommissionEmail: '是否合同佣金聯繫郵箱',
  // isNewsEmail: '是否業務新聞接收郵箱',
  isCommissionEmail: '收取合同佣金',
  isNewsEmail: '接收推廣電郵',
  deleteContactConfirm: '您確定要刪除該賬號信息嗎？',
  account: '賬號',
  setBusinessSuperior: '設置業務上司',
  loginInfo: '登錄默認賬號信息',
  defaultAccount: '賬號',
  defaultPwd: '默認密碼',
  messagingSoftware1: "通訊軟件1",
  messagingSoftware2: "通訊軟件2",
  accountFormMobileTips: '初始密碼爲手機號碼後6位',
  accountFormEmailTips: '初次登錄需要核驗郵箱，請確保輸入爲本人郵箱，核驗賬戶生效後，賬戶郵箱不能再進行修改。',
  isSetCommissionEmailTips: '當前用戶為唯一佣金聯繫郵箱，請指定新佣金聯繫人郵箱後再進行取消操作。',
}
